import { ChangeDetectionStrategy, Component, output, OnInit } from '@angular/core';
import { CoreComponent } from '../core/core.component.js';

@Component({
    selector: 'ui-emoji-selector',
    templateUrl: './emoji-selector.component.html',
    styleUrls: ['./emoji-selector.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmojiSelectorComponent extends CoreComponent implements OnInit {
	public readonly selectEmoji = output<string>();

	ngOnInit(): void {
		if (this.isBrowserPlatform()) {
			import('emoji-picker-element').then((module) => {
				document.querySelector('emoji-picker')?.addEventListener('emoji-click', (event) => {
					if (event.detail.unicode) {
						this.selectEmoji.emit(event.detail.unicode);
					}
				});
			});
		}
	}
}
